import getSchema from './getSchema';

export { default as annualSchema } from './annualSchema';
export { default as salesSchema } from './salesSchema';
export { default as pogSchema } from './pogSchema';

export default getSchema;
